import PropTypes from 'prop-types'

import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

import { Dropdown } from 'primereact/dropdown'

import style from '@aytm/app/stats/page/question-views/mn/components/controls/styles/Controls.module.scss'

// Every metrics section draws one of these, so `label` names it after its own section.
const ViewModeDropdown = ({ value, options, width, label = 'View mode', onChange }) => {
  const helpText = options?.find(o => o.value === value)?.help || ''

  const handleChange = event => {
    onChange({ viewMode: event.value })
  }

  return (
    <>
      <div className={`p-fluid ${style.dropdown}`} style={width ? { width } : undefined}>
        <Dropdown
          className="p-dropdown-rounded"
          aria-label={label}
          ariaLabel={label}
          value={value}
          options={options}
          optionValue="value"
          optionLabel="text"
          optionDisabled="disabled"
          fixedDropdownDir="bottom"
          onChange={handleChange}
        />
      </div>
      {helpText ? (
        <Popup
          width="220px"
          trigger="click"
          direction="bottomleft"
          popupOffset={9}
          hideOtherPopupsOnShow
          content={() => <p dangerouslySetInnerHTML={{ __html: helpText }} />}
        >
          <i className="icon-aytmfd-help-v2" />
        </Popup>
      ) : null}
    </>
  )
}

ViewModeDropdown.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
      listText: PropTypes.string,
      help: PropTypes.string
    })
  ),
  width: PropTypes.number,
  label: PropTypes.string,
  onChange: PropTypes.func
}

ViewModeDropdown.displayName = 'ViewModeDropdown'

export default ViewModeDropdown
